window.addEventListener("load", () => {
	const targetElement = document.getElementById("ProductGridContainer");
	const observer = new MutationObserver(() => {
		initWishlist(targetElement);
	});
	observer.observe(targetElement, { childList: true, subtree: true });
});

function initWishlist(el) {
	el.querySelectorAll("ul > div").forEach(card => {
		const wishlistElement = card.querySelector(".icon-wishlist-heart-empty");
		const formDropdown = card.querySelector(".spf-product__form select");

		const productId = formDropdown.dataset.proid;
		const variantId = formDropdown.dataset.varid;

		wishlistElement.setAttribute("data-proid", productId);
		wishlistElement.setAttribute("data-varid", variantId);
	});

	// window.HulkappWishlist.init();
	if (typeof HulkappWishlist !== 'undefined') {
		HulkappWishlist._manageCollectionWL();

		const wishlistInterval = setInterval(function () {
		if (typeof HulkappWishlist !== 'undefined') {
			
			let allHulkWishlistButtons = document.querySelectorAll('[data-wishlist]');

			if (allHulkWishlistButtons.length > 0) {
			allHulkWishlistButtons = Array.from(allHulkWishlistButtons);
			HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');

			// stop interval once elements are found
			clearInterval(wishlistInterval);
			}
		}
		}, 1000);
		
	}
}

/* === SIB: Wishlist page discount note (added 2026-06-08) === */
(function () {
	function addWishlistDiscountNote() {
		if (window.location.pathname.indexOf('/apps/advanced-wishlist') !== 0) return;
		var main = document.getElementById('MainContent');
		if (!main) return;
		if (document.getElementById('wishlist-discount-note')) return;
		var note = document.createElement('div');
		note.id = 'wishlist-discount-note';
		note.textContent = 'NOTE: Discounts will be added in Cart & Checkout.';
		note.style.cssText = 'margin:16px auto;max-width:var(--page-width,120rem);padding:12px 16px;background:#fff8e1;border:1px solid #f0c000;border-radius:6px;color:#5c4400;font-weight:600;text-align:center;line-height:1.4;';
		main.insertBefore(note, main.firstChild);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', addWishlistDiscountNote);
	} else {
		addWishlistDiscountNote();
	}
	window.addEventListener('load', addWishlistDiscountNote);
})();